<template>
  <span v-if="time">
    {{ text }}
  </span>
</template>

<script>
  import moment from 'moment'
  import 'moment-duration-format'

  export default {
    name: 'Timer',
    props: ['time'],
    data() {
      return {
        timer: false,
        text: ''
      }
    },
    watch: {
      time() {
        this.init()
      }
    },
    methods: {
      init() {
        this.text = ''
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          if (this.time) {
            let start = moment(this.time)
            let now = moment()

            let d = moment.duration(now.diff(start));
            this.text = d.format("hh:mm:ss", {trim: false})
          }
        }, 1000);
      }
    },
    mounted() {
      this.init()
    }
  }
</script>
